module.exports = __webpack_public_path__ + "img/effect-types.3e76a889.svg";